<template>
  <v-container fluid>
    <v-row>
      <Banner />
      <v-col class="form-half" cols="12" md="6">
        <v-row class="fill-height pa-0 ma-0" align="center">
          <v-col cols="12" md="9">
            <v-container>
              <img src="@/assets/Global/images/svg/dark-logo.svg" class="auth-layout-logo" alt="" />
              <br /><br />
              <div v-if="!show2fa">
                <h2>Welcome, Super Admin</h2>
                <p>Please provide your required details</p>
                <v-form ref="form" @submit.prevent="validateForm()">
                  <label>Email</label>
                  <v-text-field label="example@gmail.com" :rules="emailRules" :disabled="loading" single-line
                    color="#F36F2E" v-model="email" outlined></v-text-field>
                  <label>Password</label>
                  <v-text-field label="8+ characters" class="form-input" single-line :disabled="loading" color="#F36F2E"
                    v-model="password" :rules="passwordRules" :type="show1 ? 'text' : 'password'"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" outlined
                    @click:append="show1 = !show1"></v-text-field>
                  <Button type="submit" :loading="loading" :disabled="!isComplete">Login</Button>
                </v-form>
                <br>
                <center v-if="false">
                  <p>
                    <router-link to="/forgot-password">
                      Forgot Password ?
                    </router-link>
                  </p>
                </center>
              </div>

              <div v-else>
                <h2>2FA Authentication</h2>
                <p>{{ isVerified ? 'Enter your code' : 'You are required to set up your Two Factor Authentication to continue using the app' }}</p>
                
                <template v-if="isVerified">
                  <dtunes-otpinput v-model="otp" autofocus :CODE_LENGTH="6" />
                  <Button @click="validateCode" :loading="loading" class="mt-6">Verify</Button>
                </template>

                <two-fa-setup v-else />
              </div>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Button from "@/components/Buttons/default-button.vue";
import Banner from "../components/banner.vue";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import DtunesOtpinput from '@/components/dtunes-otp-input.vue';
import TwoFaSetup from "@/components/TwoFASetup.vue";

export default {
  data: () => ({
    loading: false,
    show1: false,
    email: "",
    password: "",
    emailRules: [
      (v) => !!v || "Email is required",
      (v) =>
        /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "Email must be valid",
    ],
    passwordRules: [(v) => !!v || "Password is required"],
    show2fa: false,
    otp: "",
  }),
  components: {
    Button,
    Banner,
    DtunesOtpinput,
    TwoFaSetup
  },
  computed: {
    ...mapState(['userDetails']),
    isComplete() {
      return this.email && this.password;
    },
    isVerified() {
      return this.userDetails && this.userDetails.isVerified;
    }
  },
  methods: {
    ...mapActions("auth", ["login", "verify2FA"]),
    validateForm() {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },
    async submitForm() {
      this.loading = true;
      let form = {
        email: this.email,
        password: this.password,
      };
      try {
        const data = await this.login(form);
        this.show2fa = true
        console.log('the data file', data);
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
        // for (const errors in err) {
        //   console.log(errors);
        //   let errorName = this[errors];
        //   this[errors + "Rules"].push(
        //     (v) => (v && v !== errorName) || err[errors]
        //   );
        //   this.$refs.form.validate();
        // }
      }
    },
    async validateCode() {
      this.loading = true;
      try {
        await this.verify2FA({
          token: this.otp,
        });
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../components/style.scss';
</style>